




























































































import { Vue, Component, Prop } from "vue-property-decorator";
import { Location } from "vue-router";

// Enums/Data
import { ListDisplayMode } from "@/data/constants";

// Types
import { IClient } from "@/models/clients";

@Component
export default class ClientListItem extends Vue {
  // Props

  @Prop({ default: ListDisplayMode.GRID })
  public displayMode!: ListDisplayMode;

  @Prop({ default: false })
  public isLoading!: boolean;

  @Prop({ default: null })
  public client!: IClient;

  // Computed

  public get isGridView() {
    return this.displayMode === ListDisplayMode.GRID;
  }

  public get showSkeletons() {
    return this.$_.isNull(this.client);
  }

  public get clientRoute(): Location {
    if (!this.client) return {};
    return {
      name: "adminClient",
      params: {
        clientId: this.client?.id
      }
    };
  }
}
